import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function validatePhone(phone: string): boolean {
  if (!phone) return false;

  const fullPhone = phone.startsWith('+') ? phone : `+${phone}`;
  const phoneNumber = parsePhoneNumberFromString(fullPhone);

  return Boolean(phoneNumber && phoneNumber.isValid());
}
